import BootstrapField from "../utility/BootstrapField";

export default class LaneClosureRequestParkingRemoval {
  constructor(data) {
    if (!data) {
      data = {};
    }
    if (data.useTestData) {
      data = {};
    }
    // each lane entry contains: lane_id, peakId, peakReason

    Object.assign(this, {
      id: new BootstrapField({
        value: typeof data.id === "number" ? data.id : null,
        required: true,
      }),
      parkingLaneId: new BootstrapField({
        value:
          typeof data.parkingLaneId === "number" ? data.parkingLaneId : null,
        required: true,
      }),
      parkingRemovalMetres: new BootstrapField({
        value:
          typeof data.parkingRemovalMetres === "number"
            ? data.parkingRemovalMetres
            : 0,
        type: BootstrapField.Types.number,
        invalidMessage: "Please enter a number",
      }),
      parkingStartAddress: new BootstrapField({
        value: data.parkingStartAddress || null,
        required: true,
      }),
      parkingEndAddress: new BootstrapField({
        value: data.parkingEndAddress || null,
        required: true,
      }),
    });
  }

  resetStatus() {
    this.status = null;
  }

  validate() {
    let errors = [];
    let flag = true;

    for (let field in this) {
      if (this[field] instanceof BootstrapField) {
        let result = this[field].validate();
        if (result === false) {
          errors.push(field);
          flag = false;
        }
      }
    }
    return flag;
  }

  getRawValue() {
    return getRawValue(this);
    function getRawValue(obj) {
      let value = {};
      if (obj instanceof BootstrapField) {
        value = obj.getRawValue();
      } else if (obj instanceof Object && Object.keys(obj).length > 0) {
        for (let key in obj) {
          if (obj[key] instanceof Array) {
            value[key] = [];
            for (let arrKey in obj[key]) {
              value[key].push(getRawValue(obj[key][arrKey]));
            }
          } else {
            value[key] = getRawValue(obj[key]);
          }
        }
      } else if (obj instanceof Array && obj.length > 0) {
        // This shouldnt ever run, as an array is also an object.
      }
      // Default, just return the value;
      else {
        value = obj;
      }
      return value;
    }
  }

  getValue() {
    return getValue(this);
    function getValue(obj) {
      let value = {};
      if (obj instanceof BootstrapField) {
        value = obj.getValue();
      } else if (obj instanceof Object && Object.keys(obj).length > 0) {
        for (let key in obj) {
          if (obj[key] instanceof Array) {
            value[key] = [];
            for (let arrKey in obj[key]) {
              value[key].push(getValue(obj[key][arrKey]));
            }
          } else {
            value[key] = getValue(obj[key]);
          }
        }
      } else if (obj instanceof Array && obj.length > 0) {
        // This shouldnt ever run, as an array is also an object.
      }
      // Default, just return the value;
      else {
        value = obj;
      }
      return value;
    }
  }

  hasChanges() {
    return false;
  }
  revertChanges() {}
  saveChanges() {}
}
